export default __webpack_public_path__ + "static/media/shopify universe 1 1.7907f5da.png";